import lightbox from '../lightbox';

if ( lightbox ) {
  lightbox.option({
      'alwaysShowNavOnTouchDevices' : true
  });
}
